function SvgWhiteBoard(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 38 31" {...props}>
      <path
        d="M36.64 5.09h-8.6l-7.41-3.84C20.52.54 19.92 0 19.19 0c-.72 0-1.32.53-1.44 1.22L10 5.09H1.52C.68 5.09 0 5.77 0 6.6v23.13c0 .84.68 1.52 1.52 1.52h35.13c.84 0 1.52-.68 1.52-1.52V6.6c-.01-.83-.69-1.51-1.53-1.51zm-18.49-2.6c.26.26.63.43 1.03.43.39 0 .75-.16 1.01-.41l4.99 2.58H12.94l5.21-2.6zM36.5 29.5H1.63V6.63H36.5V29.5z"
      />
    </svg>
  );
}

export default SvgWhiteBoard;
